import adapter from 'webrtc-adapter';
import TRTC from './main';
import { Room } from 'trtc-js-sdk-webrtc';
import { capabilityCheck } from 'trtc-js-sdk-core/src/common/rtc-detection';
import { FrameWorkType } from 'trtc-js-sdk-core';

// 避免被 tree shaking
adapter;

// @ts-ignore
TRTC.create = TRTC._create.bind(TRTC, Room);
capabilityCheck(FrameWorkType.WEBRTC);
export default TRTC;
